import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

window.Echo = new Echo({
  broadcaster: 'reverb',
  host: `ws://${process.env.VUE_APP_MIX_REVERB_HOST || window.location.hostname}:6001`,
  key: process.env.VUE_APP_MIX_REVERB_APP_KEY || 'wxhelwylkomxomketxfj',
  wsHost: process.env.VUE_APP_MIX_REVERB_HOST || window.location.hostname,
  wsPort: 6001,
  disableStats: true,
  forceTLS: true,
  encrypted: false, // Add this line
})
